import axios from "axios";
import {
  authHeader,
  authHeaderWithMultipartData,
} from "../authservice/auth-header";

const API_URL =process.env.VUE_APP_ROOT_API

class GuestService {
  // GUEST RELATED APIs

  // Get guest list
  getGuestList(filter) {
    return axios
      .get(API_URL + "guest/list" + filter, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Create guest
  createGuest(data) {
    return axios
      .post(API_URL + "guest/list", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Update guest
  editGuest(data, guest_id) {
    return axios
      .patch(API_URL + "guest/detail/" + guest_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Get guest details
  getGuestDetail(guest_id) {
    return axios
      .get(API_URL + "guest/detail/" + guest_id, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // CARD RELATED APIs

  // Get card
  getCard(guest_id) {
    return axios
      .get(API_URL + "guest/" + guest_id + "/payment-card", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Add new card
  addCard(guest_id, data) {
    return axios
      .post(API_URL + "guest/" + guest_id + "/payment-card", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  addEmvCard(guest_id, data) {
    return axios
      .post(API_URL + "guest/" + guest_id + "/payment-card-authorized", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update card
  editCard(guest_id, card_id, data) {
    return axios
      .patch(API_URL + "guest/" + guest_id + "/payment-card/" + card_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Delete card
  deleteCard(guest_id, card_id) {
    return axios.delete(
      API_URL + "guest/" + guest_id + "/payment-card/" + card_id,
      {
        headers: authHeader(),
      }
    );
  }

  // COMPANY RELATED APIs

  // Company list
  getCompanyList(filter = "") {
    return axios
      .get(API_URL + "guest/company" + filter, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Company details
  getCompanyDetails(company_id) {
    return axios
      .get(API_URL + "guest/company/" + company_id, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Create company
  createCompany(data) {
    return axios
      .post(API_URL + "guest/company", data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update company
  editCompany(company_id, data) {
    return axios
      .patch(API_URL + "guest/company/" + company_id, data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Delete company
  deleteCompany(company_id) {
    return axios
      .delete(API_URL + "guest/company/" + company_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // WAKE-UP CALL RELATED APIs

  // Get Wake-up call List
  async getWakeUpCallList() {
    const response = await axios.get(API_URL + "guest/wakeup-call", {
      headers: authHeader(),
    });
    return response.data;
  }
  // Edit Wake-up call List
  async editWakeUpCall(id, data) {
    const response = await axios.patch(
      API_URL + "guest/wakeup-call/" + id,
      data,
      {
        headers: authHeaderWithMultipartData(),
      }
    );
    return response.data;
  }
  // Delete Wake-up call List
  async deleteWakeUpCall(id) {
    const response = await axios.delete(API_URL + "guest/wakeup-call/" + id, {
      headers: authHeaderWithMultipartData(),
    });
    return response.data;
  }

  // Unused APIs

  // Delete guest
  deleteGuest(guest_id) {
    return axios
      .delete(API_URL + "guest/detail/" + guest_id, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Add Wake-up call List
  async addWakeUpCall(data) {
    const response = await axios.post(API_URL + "guest/wakeup-call" + data, {
      headers: authHeaderWithMultipartData(),
    });
    return response.data;
  }
}
export default new GuestService();
